import { createRoot } from 'react-dom/client';
import { JuniorApp } from './JuniorApp.tsx';
import './index.css';
import { KnowledgeCenterApp } from './KnowledgeCenterApp.tsx';

const juniorAppRootElement = document.getElementById('junior-app-root');

if (juniorAppRootElement) {
	const app = createRoot(juniorAppRootElement);
	const pageId = juniorAppRootElement.dataset.contentId;
	const language = juniorAppRootElement.dataset.language;

	if (!pageId || !language) throw new Error('No page id or language found');
	app.render(<JuniorApp pageId={pageId} language={language} />);
}

const knowledgeCenterAppRoot = document.getElementById('knowledge-center-root');

if (knowledgeCenterAppRoot) {
	const app = createRoot(knowledgeCenterAppRoot);
	const pageId = knowledgeCenterAppRoot.dataset.contentId;
	const language = knowledgeCenterAppRoot.dataset.language;

	if (!pageId || !language) throw new Error('No page id or language found');
	app.render(<KnowledgeCenterApp pageId={pageId} language={language} />);
}
